import { render, staticRenderFns } from "./otherVolunteerActivity.vue?vue&type=template&id=b0deae40&scoped=true&"
import script from "./otherVolunteerActivity.vue?vue&type=script&lang=js&"
export * from "./otherVolunteerActivity.vue?vue&type=script&lang=js&"
import style0 from "./otherVolunteerActivity.vue?vue&type=style&index=0&id=b0deae40&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0deae40",
  null
  
)

export default component.exports